export default __webpack_public_path__ + "static/contact-hero-1-4bdd65b8964c59c562ce270929dd0e15.png";